import { motion } from "framer-motion";
import Generated from "./assets/Generated.jpg";

const AboutHero = () => {
    return (
        <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="font-epilogue bg-[#F0F7FF] px-4 sm:px-8 md:px-12 lg:px-20 py-10 md:py-14  relative"
      >
        <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-8">

          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            className="w-full lg:w-[55%] text-center lg:text-left"
          >
            <motion.h2
              initial={{ opacity: 0, y: 40, filter: "blur(8px)" }}
              whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true }}
              className="text-[#181835] font-semibold text-[30px] sm:text-[38px] md:text-[44px] leading-tight mb-4"
            >
              Empowering Smarter  <br className="hidden md:block" /> Workforce Management for Enterprises
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 40, filter: "blur(10px)" }}
              whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
              viewport={{ once: true }}
              className="text-[#5B5B5B] text-[15px] sm:text-[16px] leading-[24px] md:leading-[26px] mb-6 max-w-xl mx-auto lg:mx-0"
            >
              JIVI Solutions delivers AI-powered workforce management software to help enterprises enhance efficiency, optimize operations, and accelerate digital transformation.
            </motion.p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
            className="relative w-full lg:w-[45%] flex justify-center items-center mt-8 lg:mt-0"
          >
            <motion.img
              src={Generated}
              alt="Man Dashboard"
              className="w-[75%] sm:w-[80%] md:w-[85%] max-w-[390px] object-contain drop-shadow-xl"
              initial={{ scale: 0.95 }}
              animate={{ scale: 1 }}
              transition={{ duration: 1.2 }}
            />
          </motion.div>
        </div>
      </motion.section>
    );
};

export default AboutHero;

